class ActivateController {
    static $inject = ['AccountService2', 'SegmentService', '$stateParams'];
    constructor(AccountService2, SegmentService, $stateParams) {
        'ngInject';
        this.AccountService2 = AccountService2;
        this.SegmentService = SegmentService;
        this.$stateParams = $stateParams;
        this.status = 'PENDING';
    }
    async activate() {
        const email = this.$stateParams.email;
        try {
            await this.AccountService2.save(email);
            this.SegmentService.setAccount({ email });
            this.SegmentService.createTrack('create-account-activated', {
                email,
            });
            this.status = 'ACTIVATED';
        }
        catch (err) {
            this.status = 'FAILED';
            console.error(err);
            throw err;
        }
    }
}
ActivateController.$inject = ['AccountService2', 'SegmentService', '$stateParams'];
export default ActivateController;
